import agent from './order/agent';
export default {
  ...agent,
};
